import React, { useContext, useState } from "react";
import styled from "styled-components";
import { Typography, Tooltip, IconButton, Icon } from "@material-ui/core";
import PeopleAltIcon from "@material-ui/icons/PeopleAlt";
import SearchIcon from "@material-ui/icons/Search";
import CloseIcon from "@material-ui/icons/Close";
import DetailsIcon from "@material-ui/icons/Details";
import SyncIcon from "@material-ui/icons/Sync";
import { UserContext } from "../../../contexts/UserContext";
import { PatronContext } from "../../../contexts/PatronContext";

const PaneHeader = ({
  title,
  icon,
  data,
  children,
  search,
  openModal,
  filter,
  setFilteredPatrons,
}) => {
  const { patrons, refreshPatrons } = useContext(PatronContext);
  const { Site } = useContext(UserContext);
  const [isSearching, setIsSearching] = useState(false);

  const toggleSearchField = () => {
    setIsSearching(!isSearching);
  };

  return (
    <HeaderContainer>
      {isSearching ? (
        children
      ) : (
        <PaneTitle variant="h5">
          {icon} {title} : {data}
        </PaneTitle>
      )}

      {search && (
        <>
          {filter}
          <PaneActions>
            {!isSearching && (
              <Tooltip title="Refresh">
                <IconButton
                  aria-label="refresh"
                  onClick={refreshPatrons}
                  color="secondary"
                >
                  <SyncIcon style={iconStyles} />
                </IconButton>
              </Tooltip>
            )}
            {(!isSearching && Site.siteType === 0) ||
            (!isSearching && Site.siteType === 5) ? (
              <Tooltip title="Filter">
                <IconButton
                  aria-label="filter"
                  onClick={openModal}
                  color="secondary"
                >
                  <DetailsIcon style={iconStyles} />
                </IconButton>
              </Tooltip>
            ) : (
              <></>
            )}

            <Tooltip title={!isSearching ? "Search" : "Clear"}>
              <IconButton
                aria-label="search"
                color="secondary"
                onClick={
                  isSearching
                    ? () => {
                        setFilteredPatrons(patrons);
                        toggleSearchField();
                      }
                    : toggleSearchField
                }
              >
                {isSearching ? (
                  <CloseIcon style={iconStyles} />
                ) : (
                  <SearchIcon style={iconStyles} />
                )}
              </IconButton>
            </Tooltip>
          </PaneActions>
        </>
      )}
    </HeaderContainer>
  );
};

const iconStyles = {
  fontSize: "35px",
};

const HeaderContainer = styled.header`
  padding: 1rem 1.2rem;
  display: flex;
  align-items: center;
  border-bottom: 1px solid;
  height: 69px;
`;

const PaneTitle = styled(Typography)`
  text-transform: uppercase;
  font-style: italic;
`;

const PaneActions = styled.div`
  display: flex;
  margin-left: auto;
`;

export default PaneHeader;
